"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var chat_1 = require("../chat");
var getSession_1 = __importDefault(require("../chat/getSession"));
var getOpponentIds = function (dialog) {
    var session = getSession_1.default(chat_1.Chat$)();
    if (!session) {
        throw new Error("User haven't a session");
    }
    if (!dialog) {
        return [];
    }
    if (!dialog.occupants_ids || !Array.isArray(dialog.occupants_ids)) {
        return [];
    }
    return dialog.occupants_ids.filter(function (id) { return id !== session.user_id; });
};
exports.default = getOpponentIds;
//# sourceMappingURL=getOpponentIds.js.map